<template>
    <div class="error-container">
        <img
            class="error-img"
            :src="errorImg"
        />
        <p class="error-tips">{{$_t('抱歉，您没有权限访问该页面。')}}</p>
    </div>
</template>

<script>
import errorImg from '@/assets/img/404.png';
export default {
    name: 'unauthorized',
    data() {
        return {
            errorImg: errorImg
        };
    }
};
</script>
<style lang="less">
.error-container {
    margin-top: 15%;
    text-align: center;
    p {
        line-height: 40px;
        color: #666;
    }
    .error-title {
        margin-top: 20px;
        font-size: 28px;
    }
    .error-tips {
        margin-top: 20px;
        font-size: 20px;
    }
}
</style>